import { ButtonText, Headline2, Headline4 } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import React from 'react'
import styled from 'styled-components'
import DynamicButton from './DynamicButton'

const Container = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    @media (max-width: 1050px) {
        height: auto;
    }
`

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 20px;
    row-gap: 30px;
    @media (max-width: 1250px) {
        grid-template-columns: 1fr 1fr;
    }
    @media (max-width: 750px) {
        grid-template-columns: 1fr;
    }
`

const InformationCard = styled.div`
    height: 330px;
    width: 350px;
    background-color: ${theme.colors.white};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 25px;
    border-radius: ${theme.borderRadius.huge};
    box-shadow: 0px 0px 100px rgba(7, 7, 7, 0.03);
    @media (max-width: 750px) {
        height: 250px;
    }
`

interface Props {
    items: {
        title: string
        subtitle: string
    }[]
    buttonText: string
    buttonLink: string
}

const InformationGrid = ({ items, buttonText, buttonLink }: Props) => {
    return (
        <Container>
            <Grid>
                {items.map((item, i) => (
                    <InformationCard key={`information-card-${i}`}>
                        <Headline2 color={theme.colors.subtitleBlack} marginBottom={30}>
                            {item.title}
                        </Headline2>
                        <Headline4 color={theme.colors.subtitleBlack}>{item.subtitle}</Headline4>
                    </InformationCard>
                ))}
            </Grid>
            <DynamicButton href={buttonLink} width={230} height={60} borderRadius={theme.borderRadius.huge}>
                <ButtonText color={theme.colors.white}>{buttonText}</ButtonText>
            </DynamicButton>
        </Container>
    )
}

export default InformationGrid
